// third-party
// types
import axiosDomain from "../../utils/axios/axiosDomain";
import { dispatch } from "../index";
import { ActivityType } from "../../types/type/activities-types";
import activity from "store/slices/activites";
import { changeLoadingOperationStatus, changeLoadingStatus } from "../slices/loading";

// -----------------------------------------------------------------------

export function getAllActivities(filterActivities: string) {
    return async () => {
        try {
            const response = await axiosDomain.get('/activities/' + filterActivities);
            if (response.data.status == 'OK') {
                dispatch(activity.actions.getAllActivities(response.data.result));
            } else {
                dispatch(activity.actions.hasError(response.data.message))
            }
        } catch (error) {
            dispatch(activity.actions.hasError(error));
        }
    };
}

export function getLastConsolidate(companyId: string) {
    return async () => {
        try {
            const response = await axiosDomain.get('/dailyclosures');
            if (response.data.status == 'OK') {
                dispatch(activity.actions.getLastConsolidate(response.data.result));
            } else {
                dispatch(activity.actions.hasError(response.data.message))
            }
        } catch (error) {
            dispatch(activity.actions.hasError(error));
        }
    };
}

export function addActivity(activityBody: ActivityType) {
    return async () => {
        try {
            dispatch(changeLoadingOperationStatus(true))
            const response = await axiosDomain.post('/activities', activityBody);
            if (response.data.status == 'OK') {
                dispatch(activity.actions.insertNewActivity(response.data.result));
            } else {
                dispatch(activity.actions.hasError(response.data.message))
            }
            dispatch(changeLoadingOperationStatus(false))
        } catch (error) {
            dispatch(activity.actions.hasError(error));
            dispatch(changeLoadingOperationStatus(false))
        }
    };
}

export function updateActivity(activityId: String | undefined, activityBody: ActivityType | undefined) {
    return async () => {
        try {
            dispatch(changeLoadingOperationStatus(true))
            const response = await axiosDomain.put('/activities/' + activityId, activityBody);
            if (response.data.status == 'OK') {
                dispatch(activity.actions.updateActivity(response.data.result));
            } else {
                dispatch(activity.actions.hasError(response.data.message))
            }
            dispatch(changeLoadingOperationStatus(false))
        } catch (error) {
            dispatch(activity.actions.hasError(error));
            dispatch(changeLoadingOperationStatus(false))
        }
    };
}

export function updateConfirmActivity(activityId: String | undefined, activityBody: any) {
    return async () => {
        try {
            dispatch(changeLoadingOperationStatus(true))
            const response = await axiosDomain.put('/activities/' + activityId, activityBody);
            if (response.data.status == 'OK') {
                dispatch(activity.actions.updateConfirmActivity(response.data.result));
            } else {
                dispatch(activity.actions.hasError(response.data.message))
            }
            dispatch(changeLoadingOperationStatus(false))
        } catch (error) {
            dispatch(activity.actions.hasError(error));
            dispatch(changeLoadingOperationStatus(false))
        }
    };
}

export function updateConfirmActivityByDay(activityBody: any) {
    return async () => {
        try {
            dispatch(changeLoadingOperationStatus(true))
            const response = await axiosDomain.post('/confirmbyplace', activityBody);

            if (response.data.status === 'OK') {
                dispatch(activity.actions.updateConfirmAllActivityByDate(activityBody));
            } else {
                dispatch(activity.actions.hasError(response.data.message))
            }
            dispatch(changeLoadingOperationStatus(false))
        } catch (error) {
            dispatch(activity.actions.hasError(error));
            dispatch(changeLoadingOperationStatus(false))
        }
    };
}

export function updateAbsenceActivity(activityId: String | undefined, activityBody: any) {
    return async () => {
        try {
            dispatch(changeLoadingOperationStatus(true))
            const response = await axiosDomain.put('/activities/' + activityId, activityBody);
            if (response.data.status == 'OK') {
                dispatch(activity.actions.updateAbsenceActivity(response.data.result));
            } else {
                dispatch(activity.actions.hasError(response.data.message))
            }
            dispatch(changeLoadingOperationStatus(false))
        } catch (error) {
            dispatch(activity.actions.hasError(error));
            dispatch(changeLoadingOperationStatus(false))
        }
    };
}

export function deleteActivity(activityId: String | undefined) {
    return async () => {
        try {
            dispatch(changeLoadingOperationStatus(true))
            const response = await axiosDomain.delete('/activities/' + activityId);
            if (response.data.status == 'OK') {
                dispatch(activity.actions.deleteActivity(activityId));
            } else {
                dispatch(activity.actions.hasError(response.data.message))
            }
            dispatch(changeLoadingOperationStatus(false))
        } catch (error) {
            dispatch(activity.actions.hasError(error));
            dispatch(changeLoadingOperationStatus(false))
        }
    };
}

export function closeActivityDay(companyId: string) {
    return async () => {
        try {
            dispatch(changeLoadingOperationStatus(true))
            await axiosDomain.post('/dailyclosures', { location_id: companyId });
            dispatch(changeLoadingOperationStatus(false))
        } catch (error) {
            dispatch(activity.actions.hasError(error));
            dispatch(changeLoadingOperationStatus(false))
        }
    };
}

export function getExternalActivity(activityId: string) {
    return async () => {
        try {
            dispatch(changeLoadingStatus(true))
            const response = await axiosDomain.get('/confirm/' + activityId);
            if (response.data.status == 'OK') {
                dispatch(activity.actions.getExternalActivity(response.data.result));
            } else {
                dispatch(activity.actions.hasError(response.data.message))
            }
            dispatch(changeLoadingStatus(false))
        } catch (error) {
            dispatch(activity.actions.hasError(error));
            dispatch(changeLoadingStatus(false))
        }
    };
}

export function updateExternalActivity(activityId: string | undefined, activityBody: any) {
    return async () => {
        try {
            dispatch(changeLoadingStatus(true))
            const response = await axiosDomain.put('/confirm/' + activityId, activityBody);
            if (response.data.status == 'OK') {
                dispatch(activity.actions.updateExternalActivity(activityBody.act_status));
            } else {
                dispatch(activity.actions.hasError(response.data.message))
            }
            dispatch(changeLoadingStatus(false))
        } catch (error) {
            dispatch(activity.actions.hasError(error));
            dispatch(changeLoadingStatus(false))
        }
    };
}

export function sendMessageActivity(activityBody: any) {
    return async () => {
        try {
            dispatch(changeLoadingOperationStatus(true))
            await axiosDomain.post('/messages', activityBody);
            dispatch(changeLoadingOperationStatus(false))
        } catch (error) {
            dispatch(activity.actions.hasError(error));
            dispatch(changeLoadingOperationStatus(false))
        }
    };
}

export function copyWeekActivities(locationId: string, currentDate: String | undefined) {
    return async () => {
        try {
            dispatch(changeLoadingOperationStatus(true))
            await axiosDomain.put('/weekdup/' + currentDate, {
                location_id: locationId
            });
            dispatch(changeLoadingOperationStatus(false))
        } catch (error) {
            dispatch(activity.actions.hasError(error));
            dispatch(changeLoadingOperationStatus(false))
        }
    };
}